import {
  useQuery,
  type QueryKey,
  type UseQueryOptions,
  type UseQueryResult,
} from "@tanstack/react-query";

/**
 * Thin portal wrapper around useQuery. Prefer this over ad-hoc useEffect + setLoading.
 * Shimmer only when `isLoading && !data` (initial load); use `isFetching` for soft refresh.
 */
export function usePortalQuery<
  TQueryFnData = unknown,
  TError = Error,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
): UseQueryResult<TData, TError> & {
  /** True only on first load with no cached/placeholder data. */
  isInitialLoading: boolean;
} {
  const result = useQuery(options);
  const isInitialLoading = result.isLoading && result.data === undefined;
  return { ...result, isInitialLoading };
}
